const DESKTOP_QUERY = '(min-width: 750px) and (any-pointer: fine)';

class ProductImageHoverZoom {
  constructor(gallery) {
    this.gallery = gallery;
    this.lens = document.createElement('span');
    this.preview = document.createElement('span');
    this.lens.className = 'product-image-zoom__lens';
    this.preview.className = 'product-image-zoom__preview';
    this.preview.setAttribute('aria-hidden', 'true');
    gallery.append(this.lens);
    document.body.append(this.preview);
    gallery.addEventListener('pointerover', this.handlePointerOver);
    gallery.addEventListener('pointermove', this.handlePointerMove);
    gallery.addEventListener('pointerout', this.handlePointerOut);
    this.mediaQuery = window.matchMedia(DESKTOP_QUERY);
    this.mediaQuery.addEventListener('change', this.hide);
  }

  handlePointerOver = (event) => {
    if (!this.mediaQuery.matches) return;
    const container = event.target instanceof Element
      ? event.target.closest('.product-media-container--image')
      : null;
    if (!container || container.closest('dialog')) return this.hide();
    const image = container.querySelector('img.product-media__image');
    if (!image) return this.hide();
    this.container = container;
    this.image = image;
    this.preview.style.backgroundImage = `url("${image.dataset.maxResolution || image.currentSrc || image.src}")`;
    this.lens.classList.add('is-visible');
    this.preview.classList.add('is-visible');
    this.update(event);
  };

  handlePointerMove = (event) => {
    if (!this.container || !this.mediaQuery.matches) return;
    if (!(event.target instanceof Element) || !event.target.closest('.product-media-container--image')) {
      return this.hide();
    }
    this.update(event);
  };

  handlePointerOut = (event) => {
    const nextTarget = event.relatedTarget;
    if (nextTarget instanceof Node && this.gallery.contains(nextTarget)) return;
    this.hide();
  };

  update(event) {
    const bounds = this.container.getBoundingClientRect();
    const x = Math.max(0, Math.min(1, (event.clientX - bounds.left) / bounds.width));
    const y = Math.max(0, Math.min(1, (event.clientY - bounds.top) / bounds.height));
    const lensWidth = Math.min(bounds.width * 0.32, 180);
    const lensHeight = Math.min(bounds.height * 0.32, 180);
    this.lens.style.width = `${lensWidth}px`;
    this.lens.style.height = `${lensHeight}px`;
    this.lens.style.left = `${bounds.left + x * bounds.width - lensWidth / 2}px`;
    this.lens.style.top = `${bounds.top + y * bounds.height - lensHeight / 2}px`;
    this.preview.style.backgroundSize = '200% 200%';
    this.preview.style.backgroundPosition = `${x * 100}% ${y * 100}%`;
    this.preview.style.top = `${Math.max(20, Math.min(window.innerHeight - this.preview.offsetHeight - 20, bounds.top))}px`;
  }

  hide = () => {
    this.container = null;
    this.lens.classList.remove('is-visible');
    this.preview.classList.remove('is-visible');
  };

  destroy() {
    this.gallery.removeEventListener('pointerover', this.handlePointerOver);
    this.gallery.removeEventListener('pointermove', this.handlePointerMove);
    this.gallery.removeEventListener('pointerout', this.handlePointerOut);
    this.mediaQuery.removeEventListener('change', this.hide);
    this.lens.remove();
    this.preview.remove();
  }
}

const initializedGalleries = new WeakMap();

const initialize = () => {
  document.querySelectorAll('media-gallery').forEach((gallery) => {
    if (!initializedGalleries.has(gallery)) {
      initializedGalleries.set(gallery, new ProductImageHoverZoom(gallery));
    }
  });
};

initialize();
new MutationObserver(initialize).observe(document.body, { childList: true, subtree: true });
